module.exports = __webpack_public_path__ + "assets/img/icon-baidu-mnp.ad7a098e.png";